import request from '../../src/state/modules/axios'

export function getTests(data){
    return request({
        url: '/api/tests',
        method: 'get',
        params: data
    })
}

export function getTestsById(data){
    return request({
        url: `/api/tests/${data.id}`,
        method: 'get',
    })
}

export function addTest(data){
    return request({
        url:'/api/tests',
        method:'post',
        data
    })
}

export function editTest(data){
    return request({
        url: `/api/tests/${data.id}`,
        method:'put',
        data
    })
}

export function getTestById(data){
    return request({
        url: `/api/tests/${data.id}`,
        method: 'get',
    })
}

export function testById(){
    return request({
        url : `/api/tests`,
        method: 'get'
    })
}

export function deleteTest(data){
    return request({
        url: `/api/tests/${data.id}`,
        method: 'delete'
    })
}


export function getApplicationTest(params) {
    return request({
        url: "/api/test/application-tests",
        method: 'get',
        params,
    })
}

export function getFinishTest(data) {
    return request({
        url:'/api/test/finish-test',
        method:'post',
        data,
    })
}

export function saveRemainingTime(data) {
    return request({
        url: "/api/test/set-remaining-time",
        method: 'post',
        data,
    })
}

export function saveUserAnswers(data){
    return request({
        url: '/api/test/set-user-answers',
        method:'post',
        data,
    })
}

export function getTestResults(params) {
    return request({
        url:'/api/test/test-results',
        method: 'get',
        params,
    })
}

export function getApplicationTests(params) {
    return request({
        url: '/api/test/get-application-test-results',
        method: 'get',
        params,
    })
}

export function getTestByAnswers(params) {
    return request({
        url: '/api/test-results/test-with-answers',
        method: 'get',
        params,
    })
}

export function changeTestStatus(data) {
    return request({
        url: '/api/test-results/update-status',
        method:'put',
        data,
    })
}
